import type { VoidFunctionComponent } from 'react';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';
import useBuildList from '../ProjectBuildsPage/useBuildList';
import BuildList from '../BuildList';

type SBOMSummaryBuildProcessProps = {
  projectId: string,
  revisionId: string,
  revision: ProjectDashboardRevision;
  onProjectChange: () => void;
};

const SBOMSummaryBuildProcess: VoidFunctionComponent<SBOMSummaryBuildProcessProps> = ({
  projectId,
  revisionId,
  revision,
  onProjectChange,
}) => {
  const {
    builds,
  } = useBuildList({
    mode: 'REVISION',
    locator: `${projectId}$${revisionId}`,
  });

  if (revision.status.submitting_build) {
    return null;
  }

  return (
    <BuildList
      builds={builds}
      currentRevision={revision}
      onLatestComplete={onProjectChange}
    />
  );
};

export default SBOMSummaryBuildProcess;
